<script>
/* eslint-disable */
import dayjs from 'dayjs';
import emit from '@ubic/vue-ui/helpers/emit';
import FunctionalComponent from '@ubic/vue-ui/mixins/functional-component';

const isFunction = obj => typeof obj === 'function';

const getMonthWeeksWithDates = context => {
  const currentMonth = dayjs(context.props.date).month();
  let date = dayjs(context.props.date)
    .locale(context.props.locale)
    .startOf('month')
    .startOf('week');

  const maxDate = context.props.maxDate
    ? +(new Date(context.props.maxDate))
    : 1 / 0;
  const minDate = context.props.minDate
    ? +(new Date(context.props.minDate))
    : -1 / 0;
  const weeks = [];

  do {
    const week = [];

    for (let i = 0; i < 7; i+=1) {
      if (date.month() === currentMonth) {
        const dn = date.day();
        week.push({
          _d: +date,
          formatted: date.format('D'),
          isInCurrentMonth: date.month() === currentMonth,
          isDisabled: +date < minDate || +date > maxDate,
          isWeekend: dn === 0 || dn === 6,
        });
      } else {
        week.push({
          _d: +date,
          formatted: '',
          isInCurrentMonth: false,
          isDisabled: true,
        });
      }

      date = date.add(1, 'day');
    }

    weeks.push(week);
  } while (date.month() === currentMonth);

  return weeks;
};

const getWeekDayTitles = context => {
  const result = [];
  let date = dayjs()
    .locale(context.props.locale)
    .startOf('week');

  for (let i = 0; i < 7; i++) {
    const weekDay = date.day();

    result.push({
      title: date.format('dd'),
      isWeekend: weekDay === 0 || weekDay === 6,
    });

    date = date.add(1, 'day');
  }

  return result;
};

const createUpdateClick = (context, d) => () => {
  if (!context.props.canEdit) {
    return false;
  }

  let dates = [...context.props.dates];

  const date = dayjs(d).format('YYYY-MM-DD');

  if (dates.includes(date)) {
    dates.splice(dates.indexOf(date), 1);
  } else {
    dates.push(date);
  }

  emit(context.listeners, 'datesupdate', dates);
};


const cssClass = 'u-calendar';

export default {
  ...FunctionalComponent,
  props: {
    date: {
      type: [Number, String],
      default: +(new Date()),
    },
    dateRenderProps: {
      type: [Object, Function],
      default: () => ({}),
    },
    maxDate: {
      type: [Number, String],
      default: null,
    },
    minDate: {
      type: [Number, String],
      default: null,
    },
    locale: {
      type: [String, Object],
      default: () => dayjs().$locale(),
    },
    dates: {
      type: Array,
      default: () => ([]),
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  render (h, context) {
    const month = dayjs(context.props.date, { locale: context.props.locale });
    const weeks = getMonthWeeksWithDates(context);
    const weekDayTitles = getWeekDayTitles(context);
    const dates = context.props.dates.map(el => Number(dayjs(el.substr(0, 10))));
    const { $style } = context;

    return (
      <table
        class={[
          cssClass,
          context.data.class,
          context.data.staticClass,
          $style.month,
        ]}
        key={context.data.key}
      >
        <thead>
          <tr>
            <td
              class={`${cssClass}__title`}
              colSpan="7"
            >
              {month.format('MMMM')}
            </td>
          </tr>
          <tr>
            {weekDayTitles.map(({ title, isWeekend }) => (
              <td
                class={[
                  `${cssClass}__day-name`,
                  { [`${cssClass}__day-name_weekend`]: isWeekend },
                ]}
              >
                {title}
              </td>
            ))}
          </tr>
        </thead>

        <tbody>
          {weeks.map((week, i) => (
            <tr key={i}>
              {week.map(date => {
                const customRenderProps = isFunction(context.props.dateRenderProps)
                  ? context.props.dateRenderProps(date)
                  : context.props.dateRenderProps;

                return (
                  <td
                    {...{
                      ...customRenderProps,
                      key: date._d,
                      class: [
                        ...(customRenderProps.class || []),
                        $style.month__day,
                        {
                          [$style.month__day_disabled]: date.isDisabled,
                          [$style.month__day_selected]: dates.includes(date._d) && date.formatted,
                        },
                      ],
                      on: {
                        click: createUpdateClick(context, date._d),
                      },
                    }}
                  >
                    {date.formatted}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    );
  },
};
/* eslint-enable */
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.month {
  border-collapse: collapse;

  &__day {
    border: solid 1px transparent;
    color: $color-gray-darkest;
    padding: 6px;
    text-align: center;

    &_selected {
      box-shadow: 0 0 0 1px $color-red-darkest inset;
      color: $color-red-darkest;
    }

    &_disabled {
      pointer-events: none;
    }

    &:hover {
      background: $color-gray-lighter;
    }
  }
}
</style>
